<template>
  <div class="modal__content">
    <slot name="notification"></slot>
    <af-h2>
      <slot name="title"></slot>
    </af-h2>
    <section>
      <slot name="content"></slot>
    </section>
  </div>
</template>

<script>
import AfH2 from '@/components/AfH2'
export default {
  name: 'ModalContent',
  components: {
    AfH2
  }
}
</script>

<style lang="postcss" scoped>
.modal__content {
  color: #000000;
  font-size: 15px;
  line-height: var(--line-height-body);
  max-width: 560px;
  padding: var(--spacing);
}
</style>



// WEBPACK FOOTER //
// src/components/ModalContent.vue